<app-form-view [formDataModel]="cost"
    [formItems]="formItems"
    (onSave)="saveClickHandler($event)"
    (onCancel)="cancelClickHandler($event)"></app-form-view>

   